const DefaultSmp = {
  // page: {
  //   data: { isFixed: true },
  //   staticFlag: false,
  // },
  app: {
    appId: '12082013',
    appStore: 'https://kuaibao.qq.com/',
    appid: '12082013',
    appkey: 'qnreading',
    auto: false,
    autoOpen: false,
    canpause: false,
    channelId: '9005084',
    copyurl:
      'σσqnreadingpaste://webview?url=https%3A%2F%2Fso.html5.qq.com%2Fpage%2Freal%2Fsearch_result%3Fq%3D%25E6%259C%2580%25E6%2596%25B0%25E8%25B5%2584%25E8%25AE%25AF&kd_channel_from=SEM_LIULANQI_BAIDU_9005084&keyword=%E5%91%A8%E6%9D%B0%E4%BC%A6&market_id=9005085σσ',
    filename: '看点快报.apk',
    key: 'app',
    packagename: 'com.tencent.reading',
    qqAppid: '',
    url: 'http://dldir1.qq.com/dlomg/chuanyue/kuaibao_9005084.apk',
    wxAppid: '',
  },

  bg: {
    data: {
      image:
        "https://smpimg-1258344701.file.myqcloud.com/smptest/SMP_20210811_6827029.jpeg",
    },
    style: {
      image:
        { width: '750px', height: '1334px' },
    },
  },
  btn: {
    data: {
      tip: '欢迎来QQ浏览器',
      init: '未下载',
      loading: '下载中_PROGRESS_%',
      downloaded: '开始安装',
      installed: '打开应用',
      downloadPause: '继续下载',
      downloadFail: '下载失败重新下载',
      installing: '正在安装',
    },
    style: {
      outer: {
        width: '750px',
        height: '200px',
        background: 'url(https://smpimg-1258344701.file.myqcloud.com/smptest/SMP_20210811_2425783.png) no-repeat',
        backgroundSize: '100% auto',
        marginTop: '330px',
      },
      loading: { backgroundColor: 'rgba(255, 255, 255, 0.3)' },
      text: {
        color: 'transparent',
      },
    },
  },
  floatBtn: {
    data: {
      tip: '欢迎来QQ浏览器',
      init: '未下载',
      loading: '下载中_PROGRESS_%',
      downloaded: '开始安装',
      installed: '打开应用',
      downloadPause: '继续下载',
      downloadFail: '下载失败重新下载',
      installing: '正在安装',
    },
    style: {
      outer: {
        width: '750px',
        height: '130px',
        background: 'url(https://smpimg-1258344701.file.myqcloud.com/smptest/202108/SMP_20210824_8383864.png) no-repeat',
        backgroundSize: '100% auto',
        position:'fixed',
        bottom:'0px',
      },
      loading: { backgroundColor: 'rgba(255, 255, 255, 0.3)' },
      text: {
        color: 'transparent',
      },
    },
  },
};

export default DefaultSmp;
